import { css } from '@emotion/react';

import { theme } from 'src/styles/theme';

export const styles = {
    loginDialogDrawer: css({
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
        '.MuiDrawer-paper': {
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            alignItems: 'flex-start',
            padding: '70px 20px 30px 20px',
            borderRadius: '15px 15px 0px 0px',
            backgroundColor: 'white',
        },
    }),
};
